import React, { useState } from 'react';
import './Login.css';
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const ResetPassword = () => {
    const { t } = useTranslation();
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        // Handle login logic here
        if (password1 !== password2) {
            alert(t('passwords-do-not-match'));
            return;
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h2>DATY ADMIN</h2>
                    <p>{t('authorized-for-daty-abaya-tz-admin-only')}</p>
                </div>
                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">password</label>
                        <input
                            type="password"
                            id="password1"
                            placeholder={t('enter-your-password')}
                            value={password1}
                            onChange={(e) => setPassword1(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">confrim password</label>
                        <input
                            type="password"
                            id="password2"
                            placeholder="confrim password"
                            value={password2}
                            onChange={(e) => setPassword2(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-options">
                        <a href="#" className="forgot-password" >
                            {t('forgot-password')}
                        </a>
                    </div>
                    {
                        loading ? (
                            <div className="loader"></div>
                        ) : (
                            <button type="submit" className="login-btn">
                                {t('sign-in')}
                            </button>
                        )
                    }
                </form>
                <a href="/" target='_parent' style={{ textDecoration: "none" }}>
                    {t('back-to-main-page')}
                </a><br />
                {/* {
                    i18n.language === "sw" ? (
                        <button style={{ textDecoration: "none",border: "none", backgroundColor:"transparent", color:"black"}} onClick={() => changeLanguage("en")}>
                            english
                        </button>
                    ) : (
                        <button style={{ textDecoration: "none",border: "none", backgroundColor:"transparent", color:"black" }} onClick={() => changeLanguage("sw")}>
                            swahili
                        </button>
                    )
                } */}

            </div>
        </div>
    );
};

export default ResetPassword;
